/*
* Palo Alto Theme
*
* Use this file to add custom Javascript to Palo Alto.  Keeping your custom
* Javascript in this fill will make it easier to update Palo Alto. In order
* to use this file you will need to open layout/theme.liquid and uncomment
* the custom.js script import line near the bottom of the file.
*/


(function() {
  // Add custom code below this line

  // Function to rearrange price and stars side by side instead of one below the other
  function rearrangePriceAndStars() {
    var parentContainer = document.querySelector('.product-single__details');

    if (parentContainer) {
        // Create a wrapper div for the flex layout
        var flexWrapper = document.createElement('div');
        flexWrapper.style.display = 'flex';
        flexWrapper.style.flexWrap = 'wrap';
        // flexWrapper.style.justifyContent = 'space-between'; // Adjust as needed
        flexWrapper.style.alignItems = 'baseline'; // Adjust as needed

        // Select specific elements. Adjust selectors as necessary.
        var priceBadgeBlock = parentContainer.querySelector('.product__price-and-badge');
        var standardAppBlock = parentContainer.querySelector('.standard__app');
        // Identify the title element after which you want to insert the flexWrapper
        var titleElement = parentContainer.querySelector('.product__title-and-price'); // Adjust the selector as needed

        if (priceBadgeBlock && standardAppBlock && titleElement) {
            // Clone elements to preserve event listeners if any
            var clonedPriceBadgeBlock = priceBadgeBlock.cloneNode(true);
            var clonedStandardAppBlock = standardAppBlock.cloneNode(true);

            // Remove the original elements
            priceBadgeBlock.remove();
            standardAppBlock.remove();

            // Append cloned elements to the flex wrapper
            flexWrapper.appendChild(clonedPriceBadgeBlock);
            flexWrapper.appendChild(clonedStandardAppBlock);

            // Insert the flex wrapper after the title element
            titleElement.insertAdjacentElement('afterend', flexWrapper);
        }
    }
  }

  // Call the function when the DOM content is loaded
  document.addEventListener('DOMContentLoaded', function() {
    rearrangePriceAndStars();
  });



  // ^^ Keep your scripts inside this IIFE function call to
  // avoid leaking your variables into the global scope.
})();
